module.exports = __webpack_public_path__ + "img/MAS (1).71427011.svg";